import React, { useContext, useState } from 'react'
import { DeleteVehicleContext, DeleteVehicleContextComp } from '../RemoveVehicleContext/DeleteVehicleContext'
import VehicleNote from '../1_Vehicle/VehicleNote/VehicleNote'
import ValidationModal from 'components/ValidationModal'
import { RemoveVehicleContext } from '../RemoveVehicleContext/RemoveVehicleContext'
import RemovableVehicles from '../1_Vehicle/RemoveVehicleBody/1_RemovableVehicles/RemovableVehicles'
import RemoveVehicleBtnNav from '../1_Vehicle/RemoveVehicleBtnNav/RemoveVehicleBtnNav'
import RequestedRemovalQuestions from '../1_Vehicle/RemoveVehicleBody/2_RequestedRemovalQuestions/RequestedRemovalQuestions'
import HelpfulDocumentsNJ from '../1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsNJ/HelpfulDocumentsNJ'
import VehicleDA from '../1_Vehicle/AddVehicleBody/6_DriverAssignment/VehicleDA_Main'
import HelpfulDocumentsPA from '../1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsPA/HelpfulDocumentsPA'
import OnlyVehicleRemoved from '../1_Vehicle/RemoveVehicleBody/3_OnlyVehicleRemoved/OnlyVehicleRemoved'
import { storageData } from 'services/Services'

const RemoveVehicleMain = (props) => {
    const removeVehicleContext = useContext(RemoveVehicleContext);
    try {
        var removedVehicles = removeVehicleContext.removeVehicleClass.vehicles.vehiclesOnPolicy.removedVehicles
    } catch (error) {
        var replaceVehClass = JSON.parse(storageData.getItem("ReplaceVehicleClass"))
        if(replaceVehClass?.requestType == "Replace Vehicle"){
            const updatedReplaceVehicleClass = {
                ...replaceVehClass,
                requestType: "Remove Vehicle",
                deleteStatus: null,
                vehicles: {
                    ...replaceVehClass.vehicles,
                    vehiclesOnPolicy: {
                        ...replaceVehClass.vehicles.vehiclesOnPolicy,
                        removedVehicles: [],
                        newVehicles: [],
                        pendingNewVehicles: [],
                        pendingRemovedVehicles: []
                    }
                }
            };
            storageData.setItem("RemoveVehicleClass", JSON.stringify(updatedReplaceVehicleClass));
            storageData.removeItem("ReplaceVehicleClass");
            const userData = JSON.parse(storageData.getItem("userData"));
            delete userData["disclosureModal"];
            storageData.setItem("userData", JSON.stringify(userData));
            window.location.replace("/endorsement/remove-vehicle")
            return;
        }
    }

    return (
        <>
            <DeleteVehicleContextComp>
                <span className='px-md-5'>

                    {!(["VehicleDriverAssignment"].includes(removedVehicles[0]?.componentTracker)) &&
                        <>
                            <h5 className='text-primary text-center fw-bold mb-4'>REMOVE VEHICLE</h5>
                            <RemovableVehicles requestContext={RemoveVehicleContext} vehicleContext={DeleteVehicleContext} endorsementType={"RemoveVehicle"} />

                            {/* Display removal questions when vehicle selected */}
                            {removeVehicleContext?.removeVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles.length > 0 && removeVehicleContext?.removeVehicleClass?.vehicles?.vehiclesOnPolicy?.storedVehicles.length > 1 &&
                                <RequestedRemovalQuestions requestContext={RemoveVehicleContext} vehicleContext={DeleteVehicleContext} endorsementType={"RemoveVehicle"} />
                            }

                            {removeVehicleContext?.removeVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles.length > 0 && removeVehicleContext?.removeVehicleClass?.vehicles?.vehiclesOnPolicy?.storedVehicles.length == 1 &&
                                <>
                                    <hr />
                                    <OnlyVehicleRemoved requestContext={RemoveVehicleContext} vehicleContext={DeleteVehicleContext} />
                                </>
                            }

                            {removeVehicleContext?.userData?.state == "New Jersey" && <HelpfulDocsNJ vehicleContext={DeleteVehicleContext}/>}
                            {removeVehicleContext?.userData?.state == "Pennsylvania" &&
                                <>
                                    <hr />
                                    <div className='d-flex justify-content-center'>
                                        <HelpfulDocumentsPA center='center' />
                                    </div>
                                </>
                            }
                        </>
                    }
                    {removedVehicles?.length > 0 && (["VehicleDriverAssignment"].includes(removedVehicles[0]?.componentTracker)) && removeVehicleContext?.removeVehicleClass?.vehicles?.vehiclesOnPolicy?.storedVehicles.length > 1 &&
                        <VehicleDA requestContext={RemoveVehicleContext} vehicleContext={DeleteVehicleContext} endorsementType={"RemoveVehicle"} />
                    }
                    <hr />
                    <VehicleNote />
                </span>
                <hr />
                <RemoveVehicleBtnNav {...props}/>
            </DeleteVehicleContextComp>

            <ValidationModal
                title={removeVehicleContext.validationTitle}
                show={removeVehicleContext.showModal}
                handleClose={() => removeVehicleContext.setShowModal(false)}
                validationMsg={removeVehicleContext.validationMsg}
            />
        </>
    )
}

const HelpfulDocsNJ = ({vehicleContext}) => {
    const deleteVehicleContext = useContext(vehicleContext)
    const removeVehicleContext = useContext(RemoveVehicleContext)
    return (
        <>
            <hr />
            <div className='d-flex justify-content-center'>
                <HelpfulDocumentsNJ policyType={removeVehicleContext.userData.policyType} effectiveDate={deleteVehicleContext.deleteVehicle?.requestedRemovalEffDate} />
            </div>
        </>
    )
}

export default RemoveVehicleMain